export default class SnackbarDisplay {
  public message = ''
  public color = ''
  public icon = ''
  public timeout = 6000
  public showClose = true
}
